import type { TariffsQuery } from '../../types/generated';

export type ProductType = 'relax' | 'komfort' | 'vario' | 'easy12' | 'easy24';

export const getProductType = (productCode: string): ProductType => {
  if (productCode.includes('EASY') && productCode.endsWith('_12')) {
    return 'easy12';
  }

  if (productCode.includes('EASY') && productCode.endsWith('_24')) {
    return 'easy24';
  }

  if (productCode.includes('RELAX')) {
    return 'relax';
  }

  if (productCode.includes('KOMFORT')) {
    return 'komfort';
  }

  return 'vario';
};

type Product = TariffsQuery['tariffs'][number];

// TODO:  "absolute" in bonus is going to be removed in favor of "instantBonusInEur"
//        -> remove the fallback once the migration is complete
export const getLoyaltyBonusInEur = (product: Product): number | undefined => {
  const { bonus } = product;

  if (!bonus) {
    return undefined;
  }

  return bonus.newCustomerBonusInEur ?? ('absolute' in bonus ? bonus.absolute : undefined);
};

export const getLoyaltyBonusInPercent = (product: Product): number | undefined => {
  const { bonus } = product;

  if (!bonus) {
    return undefined;
  }

  return bonus.newCustomerBonusInPercent ?? ('percent' in bonus ? bonus.percent : undefined);
};
